import React, { useEffect } from 'react';
import { Alert, AlertTitle, Fade, IconButton, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const StyledAlert = styled(Alert)(({ theme }) => ({
  position: 'fixed',
  top: '100px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: 'calc(100vw - 30px)',
  zIndex: 1200,

  '& .MuiAlert-message .MuiTypography-root': {
    fontSize: '16px',
  },

  '& .MuiAlert-message a': {
    textDecoration: 'underline',
  },

  '& .MuiAlertTitle-root, .MuiAlertTitle-root.MuiTypography-body1': {
    fontWeight: 600,
  },

  [theme.breakpoints.up('md')]: {
    width: '745px',
    '& .MuiAlert-message, .MuiAlert-message .MuiTypography-root': {
      fontSize: '20px',
    },
  },
}));

const StyledIconButton = styled(IconButton)({
  padding: 5,
});

export const SdmAlertV5 = ({
  severity,
  showCloseIcon = false,
  alertData,
  zIndex = 1200,
  alertCustomStyle = {},
  ...alertProps
}) => {
  useEffect(() => {
    if (!alertData?.onClose) return;
    const timer = setTimeout(
      () => alertData?.onClose(),
      alertData?.closeAfter || 6000
    );
    return () => clearTimeout(timer);
  }, [alertData]);

  return (
    <Fade
      in={!!alertData?.title}
      appear
      exit
      timeout={500}
      unmountOnExit={false}
    >
      <StyledAlert
        severity={severity}
        {...alertProps}
        sx={{ zIndex: zIndex, ...alertCustomStyle }}
      >
        <AlertTitle
          sx={{
            ...(!alertData?.message && {
              margin: '0px !important',
            }),
          }}
        >
          {alertData?.title}
        </AlertTitle>
        {alertData?.message}
        {showCloseIcon ? (
          <div
            tabIndex={0}
            role="button"
            onClick={() => alertData?.onClose()}
            style={{
              position: 'absolute',
              top: 15,
              right: 15,
            }}
          >
            <StyledIconButton>
              <CloseIcon fontSize={'small'} />
            </StyledIconButton>
          </div>
        ) : null}
      </StyledAlert>
    </Fade>
  );
};
